import { DEFAULT_LANG, SupportedLangCode } from '../../../config/languages';
import {
    getBlogArticleCanonicalUrl,
    getBlogArticleDefaultUrl,
    getBlogArticleLangUrls,
    getBlogArticlePath,
} from '../blogArticleSeo';

/** Jedinstven slug za sve jezičke verzije ovog blog posta. */
export const BLOG_WHEN_TO_SEEK_HELP_SLUG = 'blog/when-to-seek-help-from-a-psychotherapist';

/** Stari slug-ovi — redirect na BLOG_WHEN_TO_SEEK_HELP_SLUG (SEO / bookmarki). */
export const BLOG_WHEN_TO_SEEK_HELP_LEGACY_SLUGS = [
    'blog/kada-potraziti-pomoc-psihoterapeuta',
    'blog/wann-hilfe-vom-psychotherapeuten-suchen',
    'blog/quand-consulter-un-psychotherapeute',
    'blog/kogda-obratitsya-k-psihoterapevtu',
] as const;

export const getWhenToSeekHelpBlogPath = (lang: SupportedLangCode): string =>
    getBlogArticlePath(BLOG_WHEN_TO_SEEK_HELP_SLUG, lang);

export const getWhenToSeekHelpBlogCanonicalUrl = (lang: SupportedLangCode): string =>
    getBlogArticleCanonicalUrl(BLOG_WHEN_TO_SEEK_HELP_SLUG, lang);

export const getWhenToSeekHelpBlogLangUrls = () =>
    getBlogArticleLangUrls(BLOG_WHEN_TO_SEEK_HELP_SLUG);

export const getWhenToSeekHelpBlogDefaultUrl = (): string =>
    getBlogArticleDefaultUrl(BLOG_WHEN_TO_SEEK_HELP_SLUG);
